import { useContext } from "react";
import { UserContext } from "../../app/context/UserContext";

export const useUser = () => {
    const { user, setUser: _setUser } = useContext(UserContext);
    const setUser = (userName: string) => {
        if (_setUser) {
            _setUser(userName);
        }
    };
    return { user, setUser };
};
